import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import * as S from './styles';
import { color } from 'styles/pallete';
import { ItemListTabsMaterialProps } from 'types/itemListTabsMaterialProps';

interface TabsMaterialProps {
	listTabs: ItemListTabsMaterialProps[];
	getPage: React.Dispatch<React.SetStateAction<number>>;
	functionExeWithHandleChange?: any; //essa função sempre tem que retornar um booleando pra poder ou não continuar para função handleChange
}

export default function TabsMaterial({
	listTabs,
	getPage,
	functionExeWithHandleChange = () => true
}: TabsMaterialProps) {
	const [value, setValue] = React.useState(0);

	const handleChange = (_: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
		getPage(newValue);
	};

	return (
		<S.container>
			<Tabs
				value={value}
				onChange={(_, value) => {
					const canChange = functionExeWithHandleChange();
					if (canChange) {
						handleChange(_, value);
					}
				}}
				aria-label="basic tabs example"
				TabIndicatorProps={{
					style: { backgroundColor: color.system.info } // Define a cor da linha
				}}
			>
				{listTabs.map((item) => (
					<Tab
						disabled={item.disabled}
						key={item.id}
						label={item.name}
						sx={{
							color: 'gray',
							'&.Mui-selected': { color: color.system.info }
						}}
					/>
				))}
			</Tabs>
		</S.container>
	);
}
